import React, { useState } from 'react'
import { IconBulb, IconX } from '@tabler/icons-react'

import { Button } from '@/components/buttons/Button'
import {
  STORAGE_KEYS,
  readPersistedFlag,
  writePersistedFlag,
} from '@/views/VoiceAgents/canvasHelpers'

// First-load tip. Once the user dismisses it, the choice is stored under
// `voiceAgents.hintDismissed` and the hint never renders again on this device.
const CanvasHint = () => {
  const [dismissed, setDismissed] = useState(() => readPersistedFlag(STORAGE_KEYS.hintDismissed))

  if (dismissed) {
    return null
  }

  const handleDismiss = () => {
    writePersistedFlag(STORAGE_KEYS.hintDismissed, true)
    setDismissed(true)
  }

  return (
    <div className="voice-agents__canvas-hint" data-testid="canvas-hint" role="status">
      <IconBulb size={16} aria-hidden="true" />
      <span>
        <strong>Tip:</strong> Click any node to see its prompt and settings. Scroll to pan, ⇧+scroll
        to pan sideways, ⌘/Ctrl+scroll (or pinch) to zoom.
      </span>
      <Button
        basic
        square
        xs
        icon={<IconX />}
        aria-label="Dismiss tip"
        onClick={handleDismiss}
        data-testid="canvas-hint-close"
      />
    </div>
  )
}

export default CanvasHint
